import { getMessages } from '../../../../../store/constants';

export const CLASS_SEARCH_SELECT = 'search-select';
export const CLASS_SEARCH_SELECT_ITEM = 'search-select__item';
export const SEARCH_SELECT_INPUT_SELECTOR = `.${CLASS_SEARCH_SELECT} .kui-input`;

export const SEARCH_SELECT_SHOW_MORE = getMessages().getText('common.show_more');
export const NO_RESULTS = getMessages().getText('common.no_results');
export const OPTIONS_MAX_COUNT = 100; // если больше, то в дропдаун будут плавно добавляться по одному

export const SHOW_MORE_COUNT = 5;
